import { z } from 'zod/mini'

import { gtmMetadataShape } from './gtm-metadata'
import { promotionSchema } from './promotion'

export const viewPromotionSchema = z.strictObject({
  ...gtmMetadataShape,
  event: z.literal('view_promotion'),
  ecommerce: promotionSchema,
})
